import React, { useContext, useState, useEffect, memo } from 'react'
import PageLoader from 'Lib/Pageloader'
import { List, ListItem } from 'Lib/List'
import { TripListContext } from 'AccountsContainers/Trips/context'
import {
  TRIPS_LOAD_MSG_HEADING,
  TRIPS_LOAD_MSG_SUBHEADING,
  SORRY_UNABLE,
  SEEMS_THERE
} from 'AccountsConstants/language/trips'
// import { isLastPage } from 'AccountsUtils'
import { getCookie } from 'AccountsUtils'
import { getMappedValue } from '../../../../utils/arabicUtils'
import TripListDesktopItem from '../TripListDesktopItem'
import ErrorView from '../../../../components/Desktop/ErrorView'

const TripListBox = ({ props }) => {
  const {
    allUpcomingTrips,
    allPastTrips,
    tripsLoading,
    expiredTripsCount,
    tripsLoadingFailed,
    fetchTriplistForDesktop,
    lastExpiredPage,
    lastCompletedPage,
    lastArchivedPage,
    paginatedLoading,
    archivedTripsCall,
    fetchStatus,
    paymentInitializedTrips,
    piTripsFetched,
    showLoadMoreInUpcoming,
    showLoadMoreUpcomingHandler,
    showLoadMoreInCompleted,
    showLoadMoreCompletedHandler,
    // reorderTrips,
    pollComplete,
    reorderComplete
    // setReorderCompleteFlag
  } = useContext(TripListContext)

  const [upcomingSelected, updateSelectedTab] = useState(true)
  const [upcomingRequestData, updateUpcomingPayload] = useState({})
  const [expiredRequestData, updateExpiredPayload] = useState({})
  const [completedRequestData, updateCompletedPayload] = useState({})
  const [archRequestData, updateArchPayload] = useState({})
  const [archivedStarted, setArchivedFlag] = useState(false)
  const isRTL = getCookie('selectedLanguage') === 'ar'

  const fetchTrips = flag => () => {
    let apiData = { ...upcomingRequestData }
    if (flag === 'upcoming') {
      apiData = {
        pageSize: 10,
        pageNo: 0,
        tripStatus: 'upcoming'
      }
      updateUpcomingPayload(apiData)
      const pApiData = { ...apiData }
      pApiData.tripStatus = 'completed'
      updateCompletedPayload(pApiData)
    } else if (flag === 'expired') {
      apiData = { ...expiredRequestData }
      if (!apiData.pageSize) {
        apiData.pageSize = 10
      }
      if (
        lastExpiredPage > apiData.pageNo &&
        Object.keys(apiData) &&
        Object.keys(apiData).length
      ) {
        apiData.pageNo += 1
        showLoadMoreUpcomingHandler(true)
        updateExpiredPayload(apiData)
      } else if (lastExpiredPage <= apiData.pageNo) {
        showLoadMoreUpcomingHandler(false)
        return
      } else {
        apiData = {
          pageSize: 10,
          pageNo: 1,
          tripStatus: 'expired'
        }
        showLoadMoreUpcomingHandler(true)
        updateExpiredPayload(apiData)
      }
    } else if (flag === 'completed') {
      apiData = { ...completedRequestData }
      // if (!Object.keys(apiData) || !Object.keys(apiData).length) {
      //   apiData.pageNo = 0
      // }
      if (lastCompletedPage > apiData.pageNo) {
        apiData.pageNo += 1
        showLoadMoreCompletedHandler(true)
        updateCompletedPayload(apiData)
      } else if (lastCompletedPage <= apiData.pageNo) {
        apiData = {
          pageSize: 10,
          pageNo: archivedTripsCall ? 1 : 0,
          tripStatus: 'archived'
        }
        showLoadMoreCompletedHandler(true)
        updateArchPayload(apiData)
        setArchivedFlag(true)
      } else {
        apiData = {
          pageSize: 10,
          pageNo: 0,
          tripStatus: 'completed'
        }
        showLoadMoreCompletedHandler(true)
        updateCompletedPayload(apiData)
      }
    } else {
      apiData = { ...archRequestData }
      if (!apiData.pageSize) {
        apiData.pageSize = 10
      }
      if (
        lastArchivedPage > apiData.pageNo &&
        Object.keys(apiData) &&
        Object.keys(apiData).length
      ) {
        apiData.pageNo += 1
        showLoadMoreCompletedHandler(true)
        updateArchPayload(apiData)
      } else if (lastArchivedPage <= apiData.pageNo) {
        showLoadMoreCompletedHandler(false)
        return
      } else {
        apiData = {
          pageSize: 10,
          pageNo: 1,
          tripStatus: 'archived'
        }
        showLoadMoreCompletedHandler(true)
        updateArchPayload(apiData)
      }
    }
    fetchTriplistForDesktop(apiData, flag)
  }

  useEffect(() => {
    fetchTrips('upcoming')()
    fetchTrips('completed')()
  }, [])

  useEffect(() => {
    if (expiredTripsCount > 10) {
      showLoadMoreUpcomingHandler(true)
    } else {
      showLoadMoreUpcomingHandler(false)
    }
  }, [expiredTripsCount])

  useEffect(() => {
    if (lastCompletedPage > 0) {
      showLoadMoreCompletedHandler(true)
    }
  }, [allPastTrips])

  useEffect(() => {
    if (!pollComplete) {
      for (const trip of allUpcomingTrips) {
        if (
          trip.bookingStatus === 'payment initialized' ||
          trip.bookingStatus === 'payment failed'
        ) {
          fetchStatus(trip.tripId)
        }
      }
    }
    // else if (pollComplete && !reorderComplete) {
    //   reorderTrips(allUpcomingTrips, paymentInitializedTrips)
    //   setTimeout(() => {
    //     setReorderCompleteFlag(true)
    //   }, 1000)
    // }
  }, [allUpcomingTrips, pollComplete, reorderComplete])

  const selectTab = e => {
    if (
      e.currentTarget.innerText === getMappedValue('All Trips') ||
      e.currentTarget.innerText === 'All Trips'
    ) {
      updateSelectedTab(true)
    } else {
      updateSelectedTab(false)
    }
  }

  const reFire = () => {
    fetchTrips(upcomingSelected)()
  }

  const TripListHead = ({ hideTabs }) => (
    <div className="bg-grey bt bb h-13 flex flex-center pt-3" style={{
      position: 'sticky',
      top: 0,
      backgroundColor: '#f0f0f0',
      zIndex: 10,
      width: '100%',
      boxSizing: 'border-box'
    }}>
      <If condition={!hideTabs}>
        <div className="flex">
          <div
            className={
              upcomingSelected ?
                `us-text list-tab ${isRTL ? 'list-tab-right' : 'list-tab-left'
                } active-tab custom-active-tab` :
                `us-text list-tab ${isRTL ? 'list-tab-right' : 'list-tab-left'
                }`
            }
            onClick={e => selectTab(e)}
          >
            {getMappedValue('All Trips')}
          </div>
          <div
            className={
              upcomingSelected ?
                `us-text list-tab ${isRTL ? 'list-tab-left' : 'list-tab-right'
                }` :
                `us-text list-tab ${isRTL ? 'list-tab-left' : 'list-tab-right'
                } active-tab custom-active-tab`
            }
            onClick={e => selectTab(e)}
          >
            {getMappedValue('Completed Trips')}
          </div>
        </div>
      </If>
    </div>
  )

  const showDivider = (trips, index) => {
    let divider = ''
    let show = false
    let cy
    let ny
    const currentTrip = trips[index]
    if (trips && trips.length && index - 1 >= 0) {
      const prevTrip = trips[index - 1]
      cy =
        currentTrip && currentTrip.travelDate ?
          parseInt(currentTrip.travelDate.substr(0, 4), 10) :
          0
      ny =
        prevTrip && prevTrip.travelDate ?
          parseInt(prevTrip.travelDate.substr(0, 4), 10) :
          0
      show = cy !== ny
    }

    if (index === 0 || currentTrip.firstExpiredTripFlag) {
      cy =
        currentTrip && currentTrip.travelDate ?
          parseInt(currentTrip.travelDate.substr(0, 4), 10) :
          0
      show = true
    }
    if (show) {
      divider = (
        <React.Fragment>
          <div className="trip-separator us-text">{cy}</div>
        </React.Fragment>
      )
    }
    return divider
  }

  let tripsList = ''
  if (tripsLoading) {
    tripsList = (
      <PageLoader
        title={getMappedValue(TRIPS_LOAD_MSG_HEADING)}
        message={getMappedValue(TRIPS_LOAD_MSG_SUBHEADING)}
      />
    )
  } else if (tripsLoadingFailed) {
    tripsList = (
      <ErrorView
        message={getMappedValue(SORRY_UNABLE)}
        error={getMappedValue(SEEMS_THERE)}
        clickHandler={reFire}
      />
    )
  } else if (allUpcomingTrips && allUpcomingTrips.length && upcomingSelected) {
    const updateTripDetailsForPItrips = trip => {
      const updatedTrip = { ...trip }
      if (
        paymentInitializedTrips &&
        Object.keys(paymentInitializedTrips).length &&
        paymentInitializedTrips[trip.tripId] &&
        (trip.bookingStatus === 'payment initialized' ||
          trip.bookingStatus === 'payment failed')
      ) {
        updatedTrip.bookingStatus = paymentInitializedTrips[trip.tripId].status
        updatedTrip.travellers = paymentInitializedTrips[trip.tripId].msg
        updatedTrip.showLoader = false
      } else {
        updatedTrip.showLoader = true
      }
      return updatedTrip
    }
    let headerTabsVisible = true
    if (allPastTrips && allPastTrips.length) {
      headerTabsVisible = false
    }
    tripsList = (
      <>
        <TripListHead hideTabs={headerTabsVisible} />
        <List className="amb-30">
          {allUpcomingTrips.map((trip, index) => (
            <React.Fragment>
              <If condition={trip.firstExpiredTripFlag}>
                <div className="trip-category-header us-text">
                  {getMappedValue(trip.categoryHeader)}
                </div>
              </If>
              {showDivider(allUpcomingTrips, index)}
              <TripListDesktopItem
                tripDetails={updateTripDetailsForPItrips(trip)}
                key={trip.trip_ref}
                loader={piTripsFetched}
              />
            </React.Fragment>
          ))}
          <If condition={showLoadMoreInUpcoming}>
            <ListItem
              arrow={false}
              enableRipple={true}
              className={
                paginatedLoading ?
                  'us-text load-more loading' :
                  'us-text load-more'
              }
              onClick={fetchTrips('expired')}
            >
              <div className="flag h-10">
                <div className="flag__flex">
                  <h5 className="ta-c us-text">
                    {paginatedLoading ?
                      getMappedValue('Fetching Trips...') :
                      getMappedValue('Load more trips...')}
                  </h5>
                </div>
              </div>
            </ListItem>
          </If>
        </List>
      </>
    )
  } else if (allPastTrips && allPastTrips.length && !upcomingSelected) {
    let tripStatus = 'completed'
    if (archivedStarted) {
      tripStatus = 'archived'
    }
    tripsList = (
      <>
        <TripListHead />
        <List className="amb-30">
          {allPastTrips.map((trip, index) => (
            <React.Fragment>
              {showDivider(allPastTrips, index)}
              <TripListDesktopItem tripDetails={trip} key={trip.trip_ref} />
            </React.Fragment>
          ))}
          <If condition={showLoadMoreInCompleted}>
            <ListItem
              arrow={false}
              enableRipple={true}
              className={paginatedLoading ? 'load-more loading' : 'load-more'}
              onClick={fetchTrips(tripStatus)}
            >
              <div className="flag h-10">
                <div className="flag__flex">
                  <h5 className="ta-c us-text">
                    {paginatedLoading ?
                      getMappedValue('Fetching Trips...') :
                      getMappedValue('Load more trips...')}
                  </h5>
                </div>
              </div>
            </ListItem>
          </If>
        </List>
      </>
    )
  } else if (
    allPastTrips &&
    allPastTrips.length &&
    !allUpcomingTrips.length &&
    upcomingSelected
  ) {
    let tripStatus = 'completed'
    if (archivedStarted) {
      tripStatus = 'archived'
    }
    tripsList = (
      <>
        <TripListHead hideTabs={true} />
        <List className="amb-30">
          {allPastTrips.map((trip, index) => (
            <React.Fragment>
              {showDivider(allPastTrips, index)}
              <TripListDesktopItem tripDetails={trip} key={trip.trip_ref} />
            </React.Fragment>
          ))}
          <If condition={showLoadMoreInCompleted}>
            <ListItem
              arrow={false}
              enableRipple={true}
              className={paginatedLoading ? 'load-more loading' : 'load-more'}
              onClick={fetchTrips(tripStatus)}
            >
              <div className="flag h-10">
                <div className="flag__flex">
                  <h5 className="ta-c us-text">
                    {paginatedLoading ?
                      getMappedValue('Fetching Trips...') :
                      getMappedValue('Load more trips...')}
                  </h5>
                </div>
              </div>
            </ListItem>
          </If>
        </List>
      </>
    )
  } else {
    tripsList = (
      <div className="upSellCollections">
        <h1 className="empty-title us-text">
          {getMappedValue('Looks like you have not booked any trips yet.')}
          <br /> {getMappedValue('Start exploring!')}
        </h1>
        <div className="collectionBrand">
          <img
            src="https://qaui.cltp.co/images/collections/collection_brand_big.png"
            alt={getMappedValue('collections empty')}
          />
        </div>
        <nav>
          <ul className="row collectionAssets" />
        </nav>
      </div>
    )
  }

  return <React.Fragment>{tripsList}</React.Fragment>
}

export default memo(TripListBox)
